import './Footer.scss';
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';
import ReactCountryFlag from 'react-country-flag';
import XpektorLogo from '../../../../Components/XpektorLogo/XpektorLogo';
import LinkedInIcon from '../../../../Images/Icons/Linkedin.svg';

/* eslint-disable react/prop-types */
export default function Footer({ darkMode }) {
  const { t } = useTranslation();
  const [currentYear, setCurrentYear] = useState(2000);

  useEffect(() => {
    const currentDate = new Date();
    setCurrentYear(currentDate.getUTCFullYear());
  }, []);

  return (
    <div className={`home-footer ${darkMode ? 'home-footer-dark' : ''}`}>
      <div className="main-row">
        <div className="xpektor-column">
          <XpektorLogo darkMode={darkMode} />
          <p>{t('shared.footer-main-row.xpektor-column.para')}</p>
        </div>
        <div className="link-columns">
          <div className="link-column">
            <p className="column-title">
              {t('shared.footer-main-row.link-columns.lc0.column-title')}
            </p>
            <a href="/finance">{t('shared.href-label.finance')}</a>
            <a href="/advice">{t('shared.href-label.advice')}</a>
          </div>
          <div className="link-column">
            <p className="column-title">
              {t('shared.footer-main-row.link-columns.lc1.column-title')}
            </p>
            <a href="/about">{t('shared.href-label.about')}</a>
            <a href="/why">{t('shared.href-label.why')}</a>
          </div>
        </div>
      </div>
      <div className="end-row">
        <div className="interactable-row">
          <div className="country-select">
            <ReactCountryFlag
              countryCode={t('shared.footer-end-row.country-code')}
              svg
            />
            <p>{t('shared.footer-end-row.country-name')}</p>
          </div>
          <div className="links">
            <a href="/privacypolicy">{t('shared.href-label.privacy-policy')}</a>
            <a href="/termsandconditions">
              {t('shared.href-label.terms-and-conditions')}
            </a>
          </div>
        </div>
        <p>
          &copy;&nbsp;{currentYear}&nbsp;
          {t('shared.footer-end-row.copyright-suffix')}
        </p>
        <div className="social-media">
          <button
            type="button"
            onClick={() =>
              window.open(
                'https://www.linkedin.com/company/xpektortech/',
                '_blank',
                'noopener,noreferrer'
              )
            }
          >
            <img src={LinkedInIcon} alt="In" />
          </button>
        </div>
      </div>
    </div>
  );
}
